import { render, staticRenderFns } from "./CardBlogShare.vue?vue&type=template&id=5c53e0ec&scoped=true&"
import script from "./CardBlogShare.vue?vue&type=script&lang=js&"
export * from "./CardBlogShare.vue?vue&type=script&lang=js&"
import style0 from "./CardBlogShare.vue?vue&type=style&index=0&id=5c53e0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53e0ec",
  null
  
)

export default component.exports